import { FC } from "react";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import orderOptimizerTranslationsHelper from "../../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerTaxiDetailsToolButtonComponent from "../../common/tool-button/order-optimizer-taxi-details-tool-button.component";
import OrderOptimizerTaxiDetailsItem from "../../common/types/order-optimizer-taxi-details-item";

export type OrderOptimizerTaxiDetailsProps = {
  details: OrderOptimizerTaxiDetailsItem;
  idDisabled?: boolean;
  isButtonClicked: boolean;
  onSuccess: () => void;
};

const OrderOptimizerTaxiDetailsShowDrivingRouteComponent: FC<
  OrderOptimizerTaxiDetailsProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiDetailsTranslations().tools;

  return (
    <OrderOptimizerTaxiDetailsToolButtonComponent
      onClick={props.onSuccess}
      icon={faHome}
      title={translations.showDriverDrivingRouteButtonTittle}
      isDisabled={props.idDisabled}
      isButtonClicked={props.isButtonClicked}
    />
  );
};

export default OrderOptimizerTaxiDetailsShowDrivingRouteComponent;
